"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSetting = getSetting;
exports.saveSetting = saveSetting;
var _request = _interopRequireDefault(require("@/utils/request"));
function getSetting(data) {
  return (0, _request.default)({
    url: '/portal/system/newbiesubsidy/getConfigByAppId',
    method: 'post',
    data: data
  });
}
function saveSetting(data) {
  return (0, _request.default)({
    url: '/portal/system/newbiesubsidy/saveOrUpdate',
    method: 'post',
    data: data
  });
}